import React from 'react'
import { PiggyBank } from '../../features/student/PiggyBank'

const PiggyBankPage = () => {
  return <PiggyBank/>
}

export default PiggyBankPage